import { render, staticRenderFns } from "./SickLeaveCountdown.vue?vue&type=template&id=67b71b3a"
import script from "./SickLeaveCountdown.vue?vue&type=script&lang=js"
export * from "./SickLeaveCountdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports